import * as React from 'react'

import { cn } from '@/lib/utils'

export type SectionProps = Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> & {
  title?: React.ReactNode
  description?: React.ReactNode
  actions?: React.ReactNode
  contentClassName?: string
}

/** 页面内容分区容器：提供可选区块标题、说明与操作区，并统一区块内部节奏。 */
export function Section({
  title,
  description,
  actions,
  className,
  contentClassName,
  children,
  ...props
}: SectionProps) {
  const hasHeader = Boolean(title || description || actions)

  return (
    <section className={cn('space-y-4', className)} {...props}>
      {hasHeader ? (
        <div className="flex items-start justify-between gap-6">
          <div className="min-w-0 space-y-1">
            {title ? <h2 className="text-base font-medium leading-none">{title}</h2> : null}
            {description ? (
              <div className="text-sm leading-5 text-muted-foreground">{description}</div>
            ) : null}
          </div>
          {actions ? <div className="flex shrink-0 items-center gap-2">{actions}</div> : null}
        </div>
      ) : null}

      <div className={cn('min-w-0', contentClassName)}>{children}</div>
    </section>
  )
}
